import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createUserOrganisatie } from "./Reducers/actions";

const UserOrganisatieInsertPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    naam: "",
    contact: { email: "", telefoon: "", kvk: "", website: "" },
    adres: { straat: "", postcode: "", woonplaats: "" },
    actief: true,
  });
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const setField = (path, value) => {
    setForm((prev) => {
      const next = { ...prev };
      const parts = path.split(".");
      if (parts.length === 1) next[parts[0]] = value;
      else {
        next[parts[0]] = { ...next[parts[0]], [parts[1]]: value };
      }
      return next;
    });
  };

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!form.naam.trim()) {
      setError("Naam is verplicht");
      return;
    }
    setBusy(true);
    try {
      const { result } = await dispatch(createUserOrganisatie(form));
      navigate(`/admin/userorganisaties/${result._id}`);
    } catch (err) {
      setError(err.response?.error || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">Nieuwe partner-organisatie</h3>
      </div>
      <div className="box-body">
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={submit}>
          <div className="form-group">
            <label>Naam *</label>
            <input
              type="text"
              className="form-control"
              value={form.naam}
              onChange={(e) => setField("naam", e.target.value)}
              required
            />
          </div>

          <h5 className="mt-3">Contact</h5>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Email</label>
              <input
                type="email"
                className="form-control"
                value={form.contact.email}
                onChange={(e) => setField("contact.email", e.target.value)}
              />
            </div>
            <div className="col-md-6 form-group">
              <label>Telefoon</label>
              <input
                type="text"
                className="form-control"
                value={form.contact.telefoon}
                onChange={(e) => setField("contact.telefoon", e.target.value)}
              />
            </div>
            <div className="col-md-6 form-group">
              <label>KvK</label>
              <input
                type="text"
                className="form-control"
                value={form.contact.kvk}
                onChange={(e) => setField("contact.kvk", e.target.value)}
              />
            </div>
            <div className="col-md-6 form-group">
              <label>Website</label>
              <input
                type="text"
                className="form-control"
                value={form.contact.website}
                onChange={(e) => setField("contact.website", e.target.value)}
              />
            </div>
          </div>

          <h5 className="mt-3">Adres</h5>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Straat</label>
              <input
                type="text"
                className="form-control"
                value={form.adres.straat}
                onChange={(e) => setField("adres.straat", e.target.value)}
              />
            </div>
            <div className="col-md-3 form-group">
              <label>Postcode</label>
              <input
                type="text"
                className="form-control"
                value={form.adres.postcode}
                onChange={(e) => setField("adres.postcode", e.target.value)}
              />
            </div>
            <div className="col-md-3 form-group">
              <label>Woonplaats</label>
              <input
                type="text"
                className="form-control"
                value={form.adres.woonplaats}
                onChange={(e) => setField("adres.woonplaats", e.target.value)}
              />
            </div>
          </div>

          <div className="form-check mt-3">
            <input
              id="actief"
              type="checkbox"
              className="form-check-input"
              checked={form.actief}
              onChange={(e) => setField("actief", e.target.checked)}
            />
            <label htmlFor="actief" className="form-check-label">
              Actief
            </label>
          </div>

          <p className="text-muted small mt-3">
            Locaties kun je toevoegen op de detailpagina nadat de organisatie is aangemaakt.
          </p>

          <button type="submit" className="btn btn-success" disabled={busy}>
            {busy ? "Bezig..." : "Aanmaken"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UserOrganisatieInsertPage;
